interface State {
  text: string;
  value: string;
}

const getStates = (
  displayFullName?: boolean,
  excludeNonConus?: boolean,
  excludeNonContiguousStates?: boolean,
  excludeStates?: string[]
): State[] => {
  let states = [
    { text: displayFullName ? 'Alabama' : 'AL', value: 'AL' },
    { text: displayFullName ? 'Arizona' : 'AZ', value: 'AZ' },
    { text: displayFullName ? 'Arkansas' : 'AR', value: 'AR' },
    { text: displayFullName ? 'California' : 'CA', value: 'CA' },
    { text: displayFullName ? 'Colorado' : 'CO', value: 'CO' },
    { text: displayFullName ? 'Connecticut' : 'CT', value: 'CT' },
    { text: displayFullName ? 'Delaware' : 'DE', value: 'DE' },
    { text: displayFullName ? 'District of Columbia' : 'DC', value: 'DC' },
    { text: displayFullName ? 'Florida' : 'FL', value: 'FL' },
    { text: displayFullName ? 'Georgia' : 'GA', value: 'GA' },
    { text: displayFullName ? 'Idaho' : 'ID', value: 'ID' },
    { text: displayFullName ? 'Illinois' : 'IL', value: 'IL' },
    { text: displayFullName ? 'Indiana' : 'IN', value: 'IN' },
    { text: displayFullName ? 'Iowa' : 'IA', value: 'IA' },
    { text: displayFullName ? 'Kansas' : 'KS', value: 'KS' },
    { text: displayFullName ? 'Kentucky' : 'KY', value: 'KY' },
    { text: displayFullName ? 'Lousiana' : 'LA', value: 'LA' },
    { text: displayFullName ? 'Maine' : 'ME', value: 'ME' },
    { text: displayFullName ? 'Maryland' : 'MD', value: 'MD' },
    { text: displayFullName ? 'Massachusetts' : 'MA', value: 'MA' },
    { text: displayFullName ? 'Michigan' : 'MI', value: 'MI' },
    { text: displayFullName ? 'Minnesota' : 'MN', value: 'MN' },
    { text: displayFullName ? 'Mississippi' : 'MS', value: 'MS' },
    { text: displayFullName ? 'Missouri' : 'MO', value: 'MO' },
    { text: displayFullName ? 'Montana' : 'MT', value: 'MT' },
    { text: displayFullName ? 'Nebraska' : 'NE', value: 'NE' },
    { text: displayFullName ? 'Nevada' : 'NV', value: 'NV' },
    { text: displayFullName ? 'New Hampshire' : 'NH', value: 'NH' },
    { text: displayFullName ? 'New Jersey' : 'NJ', value: 'NJ' },
    { text: displayFullName ? 'New Mexico' : 'NM', value: 'NM' },
    { text: displayFullName ? 'New York' : 'NY', value: 'NY' },
    { text: displayFullName ? 'North Carolina' : 'NC', value: 'NC' },
    { text: displayFullName ? 'North Dakota' : 'ND', value: 'ND' },
    { text: displayFullName ? 'Ohio' : 'OH', value: 'OH' },
    { text: displayFullName ? 'Oklahoma' : 'OK', value: 'OK' },
    { text: displayFullName ? 'Oregon' : 'OR', value: 'OR' },
    { text: displayFullName ? 'Pennsylvania' : 'PA', value: 'PA' },
    { text: displayFullName ? 'Rhode Island' : 'RI', value: 'RI' },
    { text: displayFullName ? 'South Carolina' : 'SC', value: 'SC' },
    { text: displayFullName ? 'South Dakota' : 'SD', value: 'SD' },
    { text: displayFullName ? 'Tennessee' : 'TN', value: 'TN' },
    { text: displayFullName ? 'Texas' : 'TX', value: 'TX' },
    { text: displayFullName ? 'Utah' : 'UT', value: 'UT' },
    { text: displayFullName ? 'Vermont' : 'VT', value: 'VT' },
    { text: displayFullName ? 'Virginia' : 'VA', value: 'VA' },
    { text: displayFullName ? 'Washington' : 'WA', value: 'WA' },
    { text: displayFullName ? 'West Virginia' : 'WV', value: 'WV' },
    { text: displayFullName ? 'Wisconsin' : 'WI', value: 'WI' },
    { text: displayFullName ? 'Wyoming' : 'WY', value: 'WY' }
  ];
  if (!excludeNonConus) {
    states.push(
      { text: displayFullName ? 'Puerto Rico' : 'PR', value: 'PR' },
      { text: displayFullName ? 'U.S. Virgin Islands' : 'VI', value: 'VI' }
    );
    if (!excludeNonContiguousStates) {
      states.push(
        { text: displayFullName ? 'Alaska' : 'AK', value: 'AK' },
        { text: displayFullName ? 'Hawaii' : 'HI', value: 'HI' }
      );
    }
  }
  if (excludeStates && excludeStates.length > 0) {
    states = states.filter(s => !excludeStates.includes(s.value));
  }
  states.sort((a, b) => {
    return a.text > b.text ? 1 : -1;
  });
  return states;
};

export default getStates;
